module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh":{"message":"在线留言","name":"姓名","address":"地点","type":"信件类别","subject":"信件主题","content":"信件内容","submit":"提交","typeData":["建议","求助","投诉","咨询","其他"]},"ru":{"message":"Оставьте сообщение","name":"им","address":"мест","type":"Категория писем","subject":"Тема письма","content":"Содержание письма","submit":"представ","typeData":["Рекомендации","помощь","жалобы","консультации","другие"]}}')
  delete Component.options._Ctor
}
